<template>
    <div class="absolute flex flex-col w-full">
      <div class="services flex flex-col gap-3 mb-7.5">
        <div
            class="chosen-services w-max flex items-center py-3.75 px-5 rounded-full border"
            v-for="item in services"
            :key="item.id"
        >
          <p class="cursor-default font-semibold fz-13 uppercase">
            {{ item }}
          </p>
          <div
              class="ml-5 w-4 h-4 relative cursor-pointer"
              @click="deleteService(item)"
          >
            <div
                class="w-4 h-0.5 rotate-45 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white absolute"
            ></div>
            <div
                class="w-4 h-0.5 -rotate-45 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white absolute"
            ></div>
          </div>
        </div>
      </div>
      <div class="inputs mb-5 mr-4.5">
        <div class="field flex flex-col mb-5">
          <label for="name" class="fz-10 font-semibold uppercase mb-2.5" style="line-height: 1;"
          >{{ text.form.name }}</label
          >
          <input
              v-model="name"
              id="name"
              type="text"
              class="w-full h-12.5 pl-4"
              :class="{ error: activeErrors.indexOf(0) !== -1 }"
          />
        </div>

        <div class="field flex flex-col mb-5">
          <label for="number" class="fz-10 font-semibold uppercase mb-2.5" style="line-height: 1;"
          >{{ text.form.phone }}</label
          >
          <input
              v-model="phone"
              id="number"
              @keydown.prevent="inputPhone($event)"
              :class="{
                  error:
                    activeErrors.indexOf(1) !== -1 &&
                    activeErrors.indexOf(99) !== -1,
                }"
              type="tel"
              class="w-full h-12.5 pl-4"
          />
        </div>

        <div class="field flex flex-col">
          <label for="email" class="fz-10 font-semibold uppercase mb-2.5" style="line-height: 1;"
          >{{ text.form.email }}</label
          >
          <input
              @keypress.prevent="inputEmail($event)"
              v-model="email"
              id="email"
              type="email"
              class="w-full h-12.5 pl-4"
              :class="{
                  error:
                    activeErrors.indexOf(1) !== -1 &&
                    activeErrors.indexOf(88) !== -1,
                }"
          />
        </div>
      </div>
      <div class="formats w-full overflow-hidden">
        <p class="fz-15 font-medium mb-3.75" style="color: rgb(110, 117, 141); line-height: 1.6666;">
          {{ text.form.format }}
        </p>
        <div class="flex mt-6 w-full overflow-auto gap-2.5">
          <p
              @click="toggleFormat('phone')"
              :class="{ active: activeFormats.indexOf('phone') !== -1 }"
              style="line-height: 1;"
              class="connection-format whitespace-nowrap cursor-pointer font-semibold fz-10 uppercase py-3.75 px-5 rounded-full border"
          >
            {{ text.form.formats[0] }}
          </p>
          <p
              @click="toggleFormat('email')"
              :class="{ active: activeFormats.indexOf('email') !== -1 }"
              style="line-height: 1;"
              class="connection-format whitespace-nowrap cursor-pointer font-semibold fz-10 uppercase py-3.75 px-5 rounded-full border"
          >
            {{ text.form.formats[1] }}
          </p>
          <p
              @click="toggleFormat('telegram')"
              :class="{ active: activeFormats.indexOf('telegram') !== -1 }"
              style="line-height: 1;"
              class="connection-format whitespace-nowrap cursor-pointer font-semibold fz-10 uppercase py-3.75 px-5 rounded-full border"
          >
            {{ text.form.formats[2] }}
          </p>
          <p
              @click="toggleFormat('whatsapp')"
              :class="{ active: activeFormats.indexOf('whatsapp') !== -1 }"
              style="line-height: 1;"
              class="connection-format whitespace-nowrap cursor-pointer font-semibold fz-10 uppercase py-3.75 px-5 rounded-full border"
          >
            {{ text.form.formats[3] }}
          </p>
        </div>
        <div class="mt-2 flex flex-col gap-2 relative" style="z-index: 2">
          <p
              class="fz-10"
              style="color: rgba(255, 46, 83, 1); line-height: 1;"
              v-for="error in activeErrors"
              :key="error.id"
          >
            {{ text.errors[error] }}
          </p>
        </div>
        <button
            @click="sendForm()"
            class="mt-7.5 flex ml-auto mr-4.5 w-max become-client cursor-pointer"
            style="z-index: 2"
        >
          <div
              class=" flex gap-5 relative justify-start items-center"
              style="z-index: 2"
          >
            <p class="uppercase font-semibold fz-13">{{ text.form.send }}</p>
            <div class="plus relative w-12.5 h-12.5 rounded-full" style="background:#ff2e53;" >
              <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
              <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#fff;"></div>
            </div>

          </div>
        </button>
      </div>
    </div>

</template>

<script>
export default {
  name: "contactSecond",
  emits:['back'],
  props:['choice', 'text'],
  data() {
    return {
      activeFormats: [],
      services: [],
      name: "",
      phone: "+38 (0__) ___ - __ - __",
      phoneIndexes: ["+38 (0__) ___ - __ - __"],
      phoneActive: 0,
      email: "",
      activeErrors: [],
      additionalCodes:[]
    };
  },
  mounted() {
    this.services = [...this.choice];
  },
  methods: {
    deleteService(service) {
      if (this.services.length <= 1) {
        this.$emit('back')
      }
      this.services = this.services.filter((item) => item !== service);
    },
    sendForm() {
      this.activeErrors = [];
      if (this.name === "") {
        this.activeErrors.push(0);
      }
      if (this.phone !== this.phoneIndexes[9]) {
        if (
            this.activeFormats.indexOf("phone") !== -1 ||
            this.activeFormats.indexOf("telegram") !== -1 ||
            this.activeFormats.indexOf("whatsapp") !== -1
        ) {
          this.activeErrors.push(1);
          this.additionalCodes.push(99)
        }
      }
      if (
          this.email === "" ||
          !/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              this.email
          )
      ) {
        if (this.activeFormats.indexOf("email") !== -1) {
          if (this.activeErrors.indexOf(1) === -1) {
            this.activeErrors.push(1);
            this.additionalCodes.push(88)
          } else {
            this.additionalCodes.push(88);
          }
        }
      }
      if (
          this.phone !== this.phoneIndexes[9] &&
          this.email === "" &&
          this.activeErrors.indexOf(1) === -1
      ) {
        this.activeErrors.push(1);
        this.additionalCodes.push(99, 88)
      }
      if (this.activeFormats.length === 0) {
        this.activeErrors.push(2);
      }
      if (this.activeErrors.length > 0 || this.additionalCodes.length > 0) {
        return;
      }
    },
    inputPhone(e) {
      if (e.key.match(/[0-9]/) && this.phoneIndexes.length < 10) {
        this.phone = this.phone.replace("_", e.key);
        if (this.phoneIndexes.length < 9) {
          this.phoneIndexes.push(this.phone);
        }
        return;
      }
      if (e.key === "Backspace") {
        if (this.phoneIndexes.length === 1) {
          this.phone = this.phoneIndexes[0];
          return;
        }
        this.phone = this.phoneIndexes.pop();
      }
    },
    inputEmail(e) {
      if (e.key.match(/[A-Za-z0-9@.]/)) {
        this.email = this.email + e.key;
      }
    },
    toggleFormat(format) {
      if (this.activeFormats.indexOf(format) !== -1) {
        this.activeFormats = this.activeFormats.filter(
            (item) => item !== format
        );
      } else {
        this.activeFormats.push(format);
      }
    },
  },
}
</script>

<style scoped>

input {
  background: rgba(2, 3, 6, 0.1);
  border: 0;
  border-bottom: 1px solid #6e758d;
}
input.error {
  border-bottom: 1px solid #f22959;
}
textarea:focus,
input:focus {
  outline: none;
}
.connection-format,
.chosen-services {
  transition: all 0.3s linear;
  border-color: rgba(151, 163, 203, 0.3);
}
.connection-format:hover {
  background: rgba(151, 163, 203, 0.5);
}
.connection-format.active {
  background: rgba(151, 163, 203, 0.5);
}
</style>